var _path, _path2, _line, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2.72676V3.78491H0.5V2.72676C0.5 2.0734 0.702407 1.50053 1.00634 1.10172C1.30996 0.703337 1.69349 0.5 2.07812 0.5H16.9219C17.3065 0.5 17.69 0.703337 17.9937 1.10172C18.2976 1.50053 18.5 2.0734 18.5 2.72676Z",
    stroke: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.2729V4.20312H18.5V12.2729C18.5 12.9263 18.2976 13.4992 17.9937 13.898C17.69 14.2964 17.3065 14.4997 16.9219 14.4997H2.07812C1.69349 14.4997 1.30996 14.2964 1.00634 13.898C0.702407 13.4992 0.5 12.9263 0.5 12.2729Z",
    stroke: "#2C3E50"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 4.14453,
    x2: 19,
    y2: 4.14453,
    stroke: "#2C3E50",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.9,
    y: 8.9,
    width: 2.7,
    height: 2.7,
    rx: 0.6,
    stroke: "#2C3E50",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.27d985f306540f67db6ba056b7d25bcb.svg";
export { ForwardRef as ReactComponent };